<template>

</template>

<script>
import {ftpDownload} from "./api/view/hip/common/common";


export default {
  name: "AttachFileOut",

  data() {
    return {
      Path : '',
    }
  },  

  async mounted() {
    this.Path = this.$route.query.Path
    
    var dirs = this.Path.split('/');
    var t1 =  dirs[dirs.length - 1];
    var fname = t1.split('.');
    fname = fname[0].replace(/ /g, "")

    // var dirs = this.Path.split('/');
    // var fname = dirs[dirs.length - 1];

    console.log(this.Path, fname);

    //console.log("this Path :", this.Path);

    ftpDownload(this.Path.replace(/\//g, '\\'), fname).then((ret) =>{
      //
    }).catch(error => {
      alert('This file is not existed. Please contact HVS Purchaser!');
    })
    .finally(() => {
    })

    /*
    // 뷰어 호출
    getDwgTicket(param).then(res => {
      let ticket = res.body;

      if(ticket === undefined){
        alert('key error');
        return;
      }


      customProtocolCheck(
          ('npshmdsecuview://' + ticket),
          function() {
            //location.href = "http://s-viewer.hmd.co.kr/Setup/Launcher/eng/NpsLauncherSetup.msi";
            location.href = "http://ibiz.hvs.com.vn/sview/Setup/Launcher/eng/NpsLauncherSetup.msi";
          },
          function() {
            console.log("supported");
          }
      );
    }).finally(() => {

    })
    //http://localhost:8080/#/DwgViewer?Ship_Num=834806&Doc_Num=WB11BJ102&Rev_Num=000&UserID=A503264&key=3472088854
    //http://dwg.hmd.co.kr/pdfviewer/MIS_DocSearch_Hvs.asp?Ship_Num=123456&=" + TRIM(ls_dwg_no)+"&="+TRIM(ls_rev_no) + "&=" + Trim(gs_user_id)
    */
  },
}
</script>

<style scoped>

</style>